<template>
  <div class="home-banner-wrapper">
    <van-swipe class="my-swipe" :autoplay="3000" indicator-color="red" ref="swipeRef" @change="prepareImages">
        <van-swipe-item v-for="(item, idx) in banners" :key="item.id">
          <img v-if="preparedImages.has(idx)" @click="handleBannerClick(item)" :src="$cvWebpFn(item.imageUrl, { w: 960 })" alt="" loading="eager" :fetchpriority="idx === 0 ? 'high' : 'low'" class="banner-img" @load="onImageLoad(idx)" />
        </van-swipe-item>
      </van-swipe>

    <div class="switch-btn left-switch" @click="handlePreClick"><van-icon name="arrow-left" size="50px" /></div>
    <div class="switch-btn right-switch" @click="handleNextClick"><van-icon name="arrow" size="50px" /></div>
  </div>
</template>

<script setup lang="ts">
import { buildHomeBannerSource, buildBannerIdNameSourceValue } from '@/plugins/utils'

const props = defineProps<{ banners: IBanner[] }>()
const { preparedImages, prepareImages, onImageLoad } = useSwipeImageLoading(() => props.banners)
const { $hotKeysJump } = useNuxtApp()

const handleBannerClick = (item: IBanner) => {
  const source = buildHomeBannerSource(
    'centerBanner',
    buildBannerIdNameSourceValue(item),
    item.configType
  )
  $hotKeysJump({ linkType: item.configType, linkValue: item.value }, true, source)
}

const swipeRef = ref()
const handlePreClick = () => {
  swipeRef.value?.prev()
}
const handleNextClick = () => {
  swipeRef.value?.next()
}
</script>

<style lang="scss" scoped>
.home-banner-wrapper{
  position: relative;
  .switch-btn{
    opacity: 0;
    transition: opacity 0.5s;
    position: absolute;
    top: calc(50% - 50px);
    z-index: 9;
    cursor: pointer;
    color: rgba($color: #666, $alpha: 0.6);
  }
  &:hover .switch-btn{
    opacity: 1;
  }
  .left-switch{
    left: 20px;
  }
  .right-switch{
    right: 20px;
  }
}
.home-banner-wrapper, .my-swipe{
  height: 100%;
  width: 1900px;
  overflow: hidden;
}
.my-swipe :deep(.van-swipe__track) {
  // Vant measures track width on mount. Reserve each slide's existing 950px
  // display width at SSR instead of resolving 100% against the expanding track.
  min-width: 100%;
  display: flex;
  height: 100%;
}
.my-swipe :deep(.van-swipe-item) {
  width: 1900px;
  flex: 0 0 1900px;
  height: 100%;
}
// @media (max-width: 1800px) { 
//   .home-banner-wrapper, .my-swipe {
//     width: 1380px;
//   }
// }
.banner-img{
  width: 100%;
  height: 100%;
  display: inline-block;
  object-fit: contain;
}
</style>
